export interface QuestionOption {
  id: number;
  label: string;
  normalizedLabel: string;
  order: number;
  createdAtUtc: string;
  updatedAtUtc: string;
}

export interface Question {
  id: number;
  questionType: QuestionType;
  title: string;
  normalizedTitle: string;
  description?: string | null;
  isRequired: boolean;
  order: number;
  hasOtherOption: boolean;
  templateId: number;
  options: QuestionOption[];
  createdAtUtc: string;
  updatedAtUtc: string;
}

// Input DTOs

export interface CreateQuestionOptionInput {
  label: string;
  order: number;
}

export interface UpdateQuestionOptionInput {
  id?: number | null; // Null or 0 for new, existing ID for updates
  label: string;
  order: number;
}

export interface CreateQuestionInput {
  // templateId will be part of the route, userId for header
  questionType: QuestionType;
  title: string;
  description?: string | null;
  isRequired?: boolean;
  order: number;
  hasOtherOption?: boolean;
  options?: CreateQuestionOptionInput[];
}

export interface UpdateQuestionInput {
  questionId: number; // Must match route parameter
  // All fields are optional for update
  questionType?: QuestionType;
  title?: string;
  description?: string | null;
  isRequired?: boolean;
  order?: number;
  hasOtherOption?: boolean;
  options?: UpdateQuestionOptionInput[]; // If null, options not modified. Empty array to remove all.
}

export interface QuestionOrderItemInput {
  questionId: number;
  newOrder: number;
}

export interface ReorderQuestionsInput {
  // templateId from route, userId for header
  orderedQuestionIds: QuestionOrderItemInput[];
}

export enum QuestionType {
  /** For short, single-line answers. Corresponds to 'text' in C# comments. */
  ShortText = 'ShortText',

  /** For longer, multi-line answers. Corresponds to 'paragraph' in C# comments. */
  Paragraph = 'Paragraph',

  /** Allows selecting multiple options. Corresponds to 'checkbox' (Multiple Choice) in C# comments. */
  Checkbox = 'Checkbox',

  /** Allows selecting only one option. Corresponds to 'radio' (Single Choice) in C# comments. */
  Radio = 'Radio',

  /** Allows selecting one option from a list. Corresponds to 'dropdown' in C# comments. */
  Dropdown = 'Dropdown',

  /** For date input. Corresponds to 'date' in C# comments. */
  Date = 'Date',

  /** For time input. Corresponds to 'time' in C# comments. */
  Time = 'Time',

  /** For email input with validation. Corresponds to 'email' in C# comments. */
  Email = 'Email',

  /** For phone number input. Corresponds to 'phone' in C# comments. */
  Phone = 'Phone',

  /** For file uploads. Corresponds to 'file' in C# comments. */
  FileUpload = 'FileUpload',

  /** For ratings on a numerical scale (e.g., 1-5 stars). Corresponds to 'scale' in C# comments. */
  RatingScale = 'RatingScale',

  /** For selecting a value from a continuous range. Corresponds to 'slider' in C# comments. */
  Slider = 'Slider'
}
